// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-ebapp-js": () => import("./../../../src/pages/ebapp.js" /* webpackChunkName: "component---src-pages-ebapp-js" */),
  "component---src-pages-ficosec-js": () => import("./../../../src/pages/ficosec.js" /* webpackChunkName: "component---src-pages-ficosec-js" */),
  "component---src-pages-form-js": () => import("./../../../src/pages/form.js" /* webpackChunkName: "component---src-pages-form-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-praga-js": () => import("./../../../src/pages/praga.js" /* webpackChunkName: "component---src-pages-praga-js" */),
  "component---src-pages-yam-js": () => import("./../../../src/pages/yam.js" /* webpackChunkName: "component---src-pages-yam-js" */)
}

